import noUiSlider from 'nouislider';
import 'nouislider/dist/nouislider.css';

export function hideSections(names){
  names.forEach((name) => {
    $("#"+name+"_field").hide();
  })
}

export function showSections(names){
  names.forEach((name) => {
    $("#"+name+"_field").show();
  })
}

export function disableFieldsForSections(names){
  names.forEach((name) => {
    $("#"+name+"_field select").attr("disabled", true);
    $("#"+name+"_field input").attr("disabled", true);
    $("#"+name+"_field textarea").attr("disabled", true);
  })
}

export function enableFieldsForSections(names){
  names.forEach((name) => {
    $("#"+name+"_field select").attr("disabled", false);
    $("#"+name+"_field input").attr("disabled", false);
    $("#"+name+"_field textarea").attr("disabled", false);
  })
}

export function parseParams(querystring) {
  const params = new URLSearchParams(querystring);
  const paramsObj = {};
  for (const key of params.keys()) {
      if (params.getAll(key).length > 1) {
        paramsObj[key.replace('[]', '')] = params.getAll(key);
      } else {
        paramsObj[key] = params.get(key);
      }
  }
  return paramsObj;
}

//for people form

export function initializeAttributeValues(elem, val, clearValue=false){
  // TODO: this is very brittle, and should be removed
  var model_type = elem[0].className.split(" ")[1].split("-")[0];
  elem.select2({
    theme: "bootstrap4", 
    tags: true,
    ajax: { 
      url: '/attribute_key_options.json', 
      data: { key: val, model_type: model_type},
      dataType: 'json'
    },
    templateResult: function (res) {
      var $container = null
      $container = $("<div value="+res.id+">" + res.text + "</div>");

      return $container;
    },
    createTag: function (tag) {
      console.log(tag)
      return {
        id: `new-attribute-value: ${tag.term}`,
        text: tag.term
      }
    }
  });
  
  if(clearValue == true){
    elem.val(null).trigger("change");
  }
}

export function initializeAllAttributeKeyFields(key_classname, endpoint, entity_id = null) {
  $(key_classname).each(function() {
    var value_select_element = $(this).parent().next().find("select");
    initializeAttributeValues(value_select_element, $( this ).val(), false, $(value_select_element).val())
  });
}

export function initializeAttributeKeys(elem, endpoint, entity_id) {
  // let allow_more_values = true
  // if (entity_id) { allow_more_values = false }
  // elem.select2({
  //   theme: "bootstrap4", 
  //   tags: false,
  //   ajax: { 
  //     url: endpoint,
  //     data: function (params) {
  //       var query = { q: params.term, entity_id: entity_id }
  //       return query;
  //     },
  //     dataType: 'json'
  //   },
  //   templateResult: function (res) {
  //     var $container = null
  //     var key_included = false
  //     $(".attribute-key-select").each(function() {
  //       if ($(this).val() == res.id) key_included = true
  //     })

  //     if (key_included == false) {

  //       $container = $("<div value="+res.id+">" + res.text + "</div>");
  //     } else {
  //       $container = null
  //     }

  //     return $container;
  //   }
  // });
}

export function addNewOptionField(container_id, model_name){
  var key_div = `<select class='form-control ${model_name}-attribute-keys attribute-key-select' name='${model_name}[attributes][key][]' placeholder='Key' type='text' value='"+field_value+"'>`
  var value_div = `<select class='form-control ${model_name}-attribute-values' name='${model_name}[attributes][value][]' placeholder='Value' type='text' value='"+field_value+"'>`
  var add_btn = "<button class='btn btn-outline-success add-button' type='button'><i class='fa fa-plus' aria-hidden='true'></i></button>"
  var delete_icon = "<i class='fa fa-times' aria-hidden='true'></i>"

  const reponse_options_section = `${container_id} #attributes_field `

  $(`${reponse_options_section} .add-button`).empty().removeClass("btn-outline-success add-button").addClass("btn-outline-danger remove-button").append(delete_icon)

  var last_row_selector = ".row:last-child"
  var col_md = 'col-md-3'

  $(reponse_options_section).append("<div class='row mt-1'></div>")
  $(reponse_options_section + last_row_selector).append(`<div class='${col_md}'><div>`)
  $(reponse_options_section + last_row_selector).append(`<div class='${col_md} key-field'><div>`)
  $(reponse_options_section + last_row_selector + " .key-field").append(key_div)
  $(reponse_options_section + last_row_selector).append("<div class='col-md-5 value-field'><div>")
  $(reponse_options_section + last_row_selector + " .value-field").append(value_div)
  $(reponse_options_section + last_row_selector).append("<div class='col-md-1 button'><div>")
  $(reponse_options_section + last_row_selector + " .button").append(add_btn)
  $(reponse_options_section + last_row_selector + " .key-field input").focus();
}

export function initializeEngagmentSlider(container_div_id, allow_trigger){
  let url = new URL(window.location.href);

  var min_eng = $('#min-eng')
  var max_eng = $('#max-eng')
  var eng_slider = $(container_div_id)[0];

  if (eng_slider) {
    var min_eng_val = url.searchParams.get('engagement_from')
    var max_eng_val = url.searchParams.get('engagement_to')

    min_eng_val = (min_eng_val) ? parseInt(min_eng_val) : 0
    max_eng_val = (max_eng_val) ? parseInt(max_eng_val) : 1000000000

    min_eng.text(formatToHumanNumber(parseInt(min_eng_val)))
    max_eng.text(formatToHumanNumber(parseInt(max_eng_val)))

    noUiSlider.create(eng_slider, {
      start: [0, 100000000],
      snap: true,
      connect: true,
      range: {
          'min': 0,
          '5%': 10,
          '10%': 100,
          '15%': 1000,
          '20%': 10000,
          '30%': 50000,
          '40%': 100000,
          '50%': 500000,
          '60%': 1000000,
          '65%': 5000000,
          '70%': 10000000,
          '80%': 50000000,
          '85%': 100000000,
          '90%': 500000000,
          'max': 1000000000
      }
    });

    eng_slider.noUiSlider.on('update', function (values, handle) {
      updateEngValues(values, handle, min_eng, max_eng, eng_slider);
    });

    if(allow_trigger == true){
      eng_slider.noUiSlider.on('change', function (values, handle) {
        reloadForEngagements(values, handle, min_eng, max_eng, eng_slider);
      });
    }

    eng_slider.noUiSlider.set([parseInt(min_eng_val), parseInt(max_eng_val)]);
  }
  
}

export function initializeChannelPlatformOptions(select_elem, options) {
  for (let i = 0; i < options.length; i++) {
    select_elem.append(new Option(options[i], options[i]))
  }
}

export function initializeTypeOptions(select_elem, options, entity_type) {
  $(select_elem).html(`<select class="form-control type_values" name="${entity_type}[channels][type][]" placeholder="Option" type="text">`)
  
  for (let i = 0; i < options.length; i++) {
    $(select_elem).find(".type_values:last").append(new Option(options[i], options[i]))
  }
}

export function addNewChannelField(container_id, entity_type){
  var platform_div = `<select class="form-control platform_values" name="${entity_type}[channels][platform_name][]" placeholder="Option" type="text">`
  var url_div = `<input class="form-control" name="${entity_type}[channels][url_or_handle][]" placeholder="URL or Handle" type="text">`
  var type_div = `<input class="form-control" name="${entity_type}[channels][type][]" placeholder="Channel Type" type="text">`
  var save_btn = "<button class='btn btn-primary save-button' type='button' data-action='click->channels#createChannel'>Save <span aria-hidden='true' class='spinner-border spinner-border-sm ml-1 role='status' style='display: none;'></span></button>"
  var action_buttons = `<div class='flex flex-row'>${save_btn}<button class="ml-1 btn btn-outline-danger remove-field-button" type="button"><i class='fa fa-times' aria-hidden='true'></i></button></div>`
  var channel_field = `<input class="channel_id" name="${entity_type}[channel_ids][]" type="hidden">`
  var notice_field = '<label class="col-md-3"></label><div class="col-md-6"><span class="alert alert-danger" role="alert"></span></div>'

  const reponse_options_section = `${container_id} #channels_fields #form-fields`
  $(reponse_options_section).append("<div class='new-channel-form'></div>")

  var last_container_section = `${reponse_options_section} .new-channel-form:last `
  var last_row_selector = ".row:last-child"

  $(last_container_section).append("<div class='row mb-2'></div>")
  $(last_container_section + last_row_selector).append(`<div class='col-md-2 platform-field'><div>`)
  $(last_container_section + last_row_selector + " .platform-field").append(platform_div)
  $(last_container_section + last_row_selector).append("<div class='col-md-3 url-field'><div>")
  $(last_container_section + last_row_selector + " .url-field").append(url_div)
  $(last_container_section + last_row_selector).append("<div class='col-md-2 type-field'><div>")
  $(last_container_section + last_row_selector + " .type-field").append(type_div)
  $(last_container_section + last_row_selector).append("<div class='col-md-2 button'><div>")
  $(last_container_section + last_row_selector + " .button").append(action_buttons)
  $(last_container_section + last_row_selector).append(channel_field)
  $(last_container_section + last_row_selector + " .platform-field input").focus();

  $(last_container_section).append("<div class='row mt-3 mb-3 notice-field' style='display: none'></div>")
  $(last_container_section + last_row_selector).append(notice_field)
}

function updateEngValues(values, handle, min_eng, max_eng, ob_slider) {
  var value = values[handle];

  if (handle == 0) {
    min_eng.text(formatToHumanNumber(parseInt(value)));
  } else {
    max_eng.text(formatToHumanNumber(parseInt(value)));
  }
}

function formatToHumanNumber(value) {
  if(value >= 1000000000){
    return (value / 1000000000).toFixed(0) + 'B'
  } else if (value >= 1000000) {
    return (value / 1000000).toFixed(0) + 'M'
  } else if (value >= 100000) {
    return (value / 1000).toFixed(0) + 'K'
  } else if (value >= 10000) {
    return (value / 1000).toFixed(0) + 'K'
  } else if (value >= 1000) {
    return (value / 1000).toFixed(0) + 'K'
  } else {
    return value
  }
}

function reloadForEngagements(values, handle, min_eng, max_eng, eng_slider){
  setTimeout(function(){ 
    let url = new URL(window.location.href);

    var values = eng_slider.noUiSlider.get()
    values[0] !== '0.00' && url.searchParams.set('engagement_from', values[0])

    values[1] !== '1000000000.00'&& url.searchParams.set('engagement_to', values[1])
  
    window.location.href = url.href;
  }, 1000);
}


